import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import { logoutRoute } from "../../utils/APIRoutes";

// import 'react-select/dist/react-select.css';

const Header = ({ setToggle }) => {
  const location = useLocation();

  const navigate = useNavigate();
  const [selectedOption, setselectedOption] = useState({
    value: "profile",
    label: "Profile",
  });
  const handleToggle = () => {
    setToggle((current) => !current);
  };
  const options = [
    { value: "profile", label: "Profile" },
    { value: "identity-data", label: "Identity Data" },
    { value: "investments", label: "Investments" },
    { value: "income-data", label: "Income Data" },
    { value: "balances", label: "Balances" },
    { value: "liabilities", label: "Liabilities" },
    { value: "student-loans", label: "Student Loans" },
    { value: "credit-cards", label: "Credit Cards" },
    { value: "transaction-history", label: "Transaction History" },
  ];
  const handleChange = (selectedOption) => {
    console.log("selectedOption", selectedOption.value);
    if (selectedOption.value === "profile") {
      navigate(`/`);
    } else {
      navigate(`/${selectedOption.value}`);
    }
    setselectedOption(selectedOption);
  };
  const handleLogout = async () => {
    console.log("Starting log out process")
    const id = await JSON.parse(localStorage.getItem("chat-app-current-user"))
      ._id;
    const data = await axios.get(`${logoutRoute}/${id}`);
    if (data.status === 200) {
      localStorage.clear();
      navigate("/login");
    }
  };
  return (
    <nav className="navbar navbar-expand  navbar-dark sticky-top px-4 py-0">
      <Link to="/" className="navbar-brand d-flex d-lg-none me-4">
        <img className="moblogo" src="img/logo-icon.png" alt="" />
      </Link>
      <Link
        to=""
        className="sidebar-toggler flex-shrink-0"
        id="sidebar-toggler"
        onClick={handleToggle}
      >
        <i className="fa fa-bars"></i>
      </Link>
      <div className="navbar-nav align-items-center ms-auto">
        <div className="nav-item dropdown">
          <Link
            to=""
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            <img
              className="rounded-circle me-lg-2"
              src="img/user.jpg"
              alt=""
              style={{ width: "40px", height: "40px" }}
            />
          </Link>
          <div className="dropdown-menu dropdown-menu-end bg-secondary border-0 rounded-0 rounded-bottom m-0">
            <Link to="" className="dropdown-item">
              My Profile
            </Link>
            <Link to="" className="dropdown-item">
              Settings
            </Link>
            <Link to="" className="dropdown-item" onClick={handleLogout}>
              Log Out
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
